import { TabBody } from '@components/Tabs/components/TabBody'
import { BookCollection } from '@features/myReading/components/BookCollection'
import { BookListTabProps } from './interface'

export function BookListTab({
  bookCollections,
  handleGoToBookCollectionDetail,
}: BookListTabProps) {
  return (
    <TabBody tabId='bookList'>
      <div className='border-t border-gray-3 dark:border-purple'>
        {bookCollections?.length > 0 ? (
          <div className='items-start grid grid-cols-4 tablet:grid-cols-2 mobile:grid-cols-1 justify-items-center gap-x-[20px] gap-y-[30px] mt-[20px]'>
            {bookCollections.map(collection => (
              <BookCollection
                key={collection.id}
                collectionName={collection.collectionName}
                privacyType={collection.privacyType}
                books={collection.books}
                goToBookCollectionDetail={() =>
                  handleGoToBookCollectionDetail(collection.id)
                }
              />
            ))}
          </div>
        ) : (
          <div className='flex flex-col items-center justify-center py-[60px]'>
            <p className='font-mitr font-medium text-[24px] text-secondary-1'>
              ไม่พบลิสต์หนังสือ
            </p>
          </div>
        )}
      </div>
    </TabBody>
  )
}
